import axios from "axios";
import { HttpClient, RequestParams } from "../../utils/api/http-client";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import { ISkipReasonQuery } from "../../models/skip-reason/query";
import { ISkipReason } from "../../models/skip-reason/response";
import {
  ICreateSkipReason,
  IExportSkipReasonExcel,
  IUpdateSkipReason,
} from "../../models/skip-reason/request";
import { ACCESS_TOKEN, LANGUAGE_CODE } from "../../utils/helpers/constants";

class SkipReasonService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  getAllSkipReasons = (query: ISkipReasonQuery, params?: RequestParams) =>
    this.http.request<IBaseListingResponse<ISkipReason>>({
      path: `/admin/skip-reasons`,
      method: "GET",
      query,
      ...params,
    });

  getSkipReason = (id: number, params?: RequestParams) =>
    this.http.request<ISkipReason>({
      path: `/admin/skip-reasons/${id}`,
      method: "GET",
      ...params,
    });

  createSkipReason = (data: ICreateSkipReason, params?: RequestParams) =>
    this.http.request<ISkipReason>({
      path: "/admin/skip-reasons",
      method: "POST",
      body: data,
      ...params,
    });

  updateSkipReason = (
    id: number,
    data: IUpdateSkipReason,
    params?: RequestParams
  ) =>
    this.http.request<ISkipReason>({
      path: `/admin/skip-reasons/${id}`,
      method: "PUT",
      body: data,
      ...params,
    });

  deleteSkipReason = (id: number, params?: RequestParams) =>
    this.http.request<ISkipReason>({
      path: `/admin/skip-reasons/${id}`,
      method: "DELETE",
      ...params,
    });

  exportExcel = (data: IExportSkipReasonExcel, query: ISkipReasonQuery) =>
    axios.post(
      `${process.env.REACT_APP_BASE_API_URL}/admin/skip-reasons/export`,
      data,
      {
        headers: {
          authorization: `Bearer ${
            localStorage.getItem(ACCESS_TOKEN) ||
            sessionStorage.getItem(ACCESS_TOKEN)
          }`,
          "Content-Type": "application/json",
          "accept-language": `${
            localStorage.getItem(LANGUAGE_CODE) ??
            process.env.REACT_APP_DEFAULT_LANGUAGE
          }`,
        },
        params: query,
        responseType: "arraybuffer",
      }
    );
}

export default SkipReasonService;
